import { render, staticRenderFns } from "./OverviewProfileSummaryCard.vue?vue&type=template&id=560f8482"
import script from "./OverviewProfileSummaryCard.vue?vue&type=script&lang=js"
export * from "./OverviewProfileSummaryCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports